"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

const REFERRAL_STORAGE_KEY = "referral_code";
const REFERRAL_EXPIRY_KEY = "referral_code_expires_at";
const REFERRAL_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

function isBrowser() {
  return typeof window !== "undefined";
}

export function setReferralCode(code: string) {
  if (!isBrowser() || !code) return;

  const trimmed = code.trim();
  if (!trimmed) return;

  const expiresAt = Date.now() + REFERRAL_TTL_MS;

  localStorage.setItem(REFERRAL_STORAGE_KEY, trimmed);
  localStorage.setItem(REFERRAL_EXPIRY_KEY, String(expiresAt));
}

export function clearReferralCode() {
  if (!isBrowser()) return;

  localStorage.removeItem(REFERRAL_STORAGE_KEY);
  localStorage.removeItem(REFERRAL_EXPIRY_KEY);
}

export function getReferralCode(): string | null {
  if (!isBrowser()) return null;

  const code = localStorage.getItem(REFERRAL_STORAGE_KEY);
  const expiresAtRaw = localStorage.getItem(REFERRAL_EXPIRY_KEY);

  if (!code || !expiresAtRaw) {
    clearReferralCode();
    return null;
  }

  const expiresAt = Number(expiresAtRaw);

  if (!Number.isFinite(expiresAt) || Date.now() > expiresAt) {
    clearReferralCode();
    return null;
  }

  return code;
}

export function useReferral() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ref = searchParams?.get("ref");

    if (ref) {
      setReferralCode(ref);
      return;
    }

    getReferralCode();
  }, [searchParams]);
}